module.exports = __webpack_public_path__ + "img/couponE.d8de5491.png";